import { FC } from "react";
import { Box } from "@mui/material";
import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { testDriveAndContactUs } from "../hardCodeData";

const TestDriveAndContactUs: FC = () => {
  const { t } = useTranslation();
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: { xs: "column", md: "row" },
        height: { xs: "200vw", md: "35vw" },
      }}
    >
      {testDriveAndContactUs.map((item, i) => {
        return (
          <Box
            key={i}
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "end",
              height: { xs: "100vw", md: "calc(100% - 75px)" },
              width: { xs: "100%", md: "50%" },
              background: `url(${item.img})`,
              backgroundSize: { xs: "cover", md: item.name === "service" ? "130%" : "100%" },
              backgroundPosition: "center center",
              transition: "background-size ease-in-out .25s",
              pb: "75px",
              "&:hover": {
                backgroundSize: { xs: "cover", md: item.name === "service" ? "133%" : "103%" },
              },
              borderTop: { xs: "none", md: "#fff solid 2px" },
              borderBottom: { xs: "none", md: "#fff solid 2px" },
              borderRight: {
                xs: "none",
                md: i === 0 ? "#fff solid 2px" : "none",
              },
              borderLeft: { xs: "none", md: "none" },
            }}
          >
            <NavLink className="testDriveAndContactUsMain" to={item.path}>
              {t(`common:${item.name}`)}
            </NavLink>
          </Box>
        );
      })}
    </Box>
  );
};

export default TestDriveAndContactUs;
